var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 34,
    viewBox: "0 0 41 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.86 4.98C32.66 1.767 28.536.092 23.998 0h-11.39A12.717 12.717 0 0 0 0 12.77c0 7.042 5.709 12.77 12.726 12.77h11.272c4.694 0 8.393-3.831 8.393-8.541 0-4.71-3.819-8.541-8.512-8.541h-11.5l-1.667 6.427h13.166c1.162 0 2.107.948 2.107 2.114a2.112 2.112 0 0 1-2.107 2.114h-11.27c-3.486 0-6.202-2.846-6.202-6.343s2.71-6.286 6.201-6.342h11.385C29.8 6.428 34.409 11.17 34.409 17c0 5.83-4.726 10.573-10.537 10.573H8.352L6.685 34h17.314c4.513-.086 8.66-1.768 11.86-4.98A16.916 16.916 0 0 0 40.822 17a16.91 16.91 0 0 0-4.963-12.02Z",
    fill: "#05DB4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlueLogo);
export default __webpack_public_path__ + "static/media/glue-logo.79d1ceecf0f53a3bd8ed83373c7b5c5d.svg";
export { ForwardRef as ReactComponent };